import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { SessionService } from 'src/app/services/session.service';
@Injectable({
  providedIn: 'root'
})
export class AwsSharedService {

  constructor(
    private http: HttpClient,
    private sessionService: SessionService
  ) { }

  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'client-id': 'apliclientesksks',
      'client-hash': 'apliclientesksks',
      'Auth': this.sessionService.token
    }),
  };

   private httpOptionsNew = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.sessionService.token}`
    })
  };

  download_file(url: string): Observable<Blob> {
    return this.http.get(url, { responseType: 'blob' })
  }

  getCompany(body){
    return this.http.post(`${environment.baseUrlAPI}/user/company`, body,  this.httpOptions);
  }

  updateNotificationsToTrue(){
    return this.http.post(`${environment.baseUrlAPI}/user/updateNotificationsToTrue`, {}, this.httpOptions);
  }

  listChatParticipantCompanyUnread(body){
    return this.http.post(`${environment.baseUrlAPI}/user/listChatParticipantCompanyUnread`, body, this.httpOptions);
  }

  listChatParticipantUnreadAll(body){
    return this.http.post(`${environment.baseUrlAPI}/user/listChatParticipantUnreadAll`, body, this.httpOptions);
  }

  quantityMessageUnreadChatCompany(body){
    return this.http.post(`${environment.baseUrlAPI}/user/quantityMessageUnreadChatCompany`, body, this.httpOptions);
  }

  quantityMessageUnreadChatAll(body){
    return this.http.post(`${environment.baseUrlAPI}/user/quantityMessageUnreadChatAll`, body, this.httpOptions);
  }

  getPlanUserCompany(body){
    return this.http.post(`${environment.baseUrlAPI}/user/getPlanUserCompany`, body,  this.httpOptions);
  }

  dependencyCompanyHub(body){
    return this.http.post(`${environment.baseUrlAPI}/hub/dependencyCompanyHub`, body, this.httpOptions);
  }

  uploadFileS3All(body){
    return this.http.post(`${environment.baseUrlAPI}/user/uploadFile`, body, this.httpOptions);
  }

  getCountries() {
    return this.http.post(`${environment.baseUrlAPI}/listCountries`,{},this.httpOptions);
  }

  updateAvatar(body) {
    return this.http.post(`${environment.baseUrlAPI}/user/updateAvatar`,body,this.httpOptions);
  }

  uploadFileToS3(body){
    let httpFormaData = new HttpHeaders({
      'Content-Type': 'multipart/form-data',
    }); 
    return this.http.put(body['url'], body['file'], { headers: httpFormaData, reportProgress: true, observe: 'events' });
  }

  uploadFileToS3Response(body){
    let httpFormaData = new HttpHeaders({
      'Content-Type': 'multipart/form-data',
    }); 
    return this.http.put(body['url'], body['file'], { headers: httpFormaData, observe: 'response' });
  }

  //Aceptar invitación de usuario de una empresa
  acceptinviteBusinessUser(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/userPanel/invitations/accept`, body, this.httpOptionsNew);
  }

  //Rechazar invitación de usuario de una empresa
  rejectedinviteBusinessUser(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/userPanel/invitations/reject`, body, this.httpOptionsNew);
  }

  getStatusCompany(idCompany: string) {
    return this.http.post(`${environment.baseUrlAPI}/user/statusCompany`,{ id: idCompany }, this.httpOptions);
  }

  uploadFileS3AllExternal(body){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/public/contractManagement/approval/uploadFile`, body, this.httpOptionsNew); 
  }

  graphicUser(body){
    return this.http.post(`${environment.baseUrlAPI}/user/tutorial/graphic`, body , this.httpOptions);
  }

  graphicCompany(body){
    return this.http.post(`${environment.baseUrlAPI}/company/tutorial/graphic`, body , this.httpOptions);
  }

  //cerrar sesion
  logoutUser(){
    return this.http.post(`${environment.baseUrlAPINEW}/authentication/logoutUser`, {},  this.httpOptionsNew);
  }

  //Notificaciones
  notifications(){
    return this.http.post(`${environment.baseUrlAPINEW}/user/home/topBar/notifications`, {},  this.httpOptionsNew);
  }

  //Leer notificación
  readNotification(body){
    return this.http.put(`${environment.baseUrlAPINEW}/user/home/topBar/readNotification`, body,  this.httpOptionsNew);
  }

  //Chat participantes
  unreadParticipantChat(){
    return this.http.post(`${environment.baseUrlAPINEW}/user/home/topBar/unreadParticipantChat`, {},  this.httpOptionsNew);
  }

  //Actualizar tema e idioma
  saveUserPreferences(body){
    return this.http.put(`${environment.baseUrlAPINEW}/user/home/topBar/saveUserPreferences`, body,  this.httpOptionsNew);
  }

  //Notificaciones no vistas
  getNotificationsNotShow(){
    return this.http.post(`${environment.baseUrlAPINEW}/user/home/topBar/notificationsNotShow`, {}, this.httpOptionsNew);
  }

  //Empresas logos
  getCompaniesVerified() {
    return this.http.post(`${environment.baseUrlAPINEW}/user/home/topBar/myCompanies`,{}, this.httpOptionsNew);
  }
}
